<template>
    <ww-open-data :type="type" :openid="openid" />
</template>

<script>
    export default {
        name: "openData",
        props:["type","openid"],
        created() {
            WWOpenData.bind(this.$el)
        },
        mounted() {
            this.$nextTick(()=>{
                WWOpenData.bind(this.$el)
            })
        }
    };
</script>

<style scoped>

</style>